import { DraggableProvided, DraggableStateSnapshot } from '@hello-pangea/dnd'
import React from 'react'

import { LocalAction, LocalActionType, LocalNonEmptyAction } from '@/app/module/campaigns/types'
import { ActionOption } from '@/app/module/campaigns/utils/actions/options'
import { FilesType, PersonalizationType } from '@/app/types'

import Action from './action'

type Props = {
  action: LocalAction
  actionOptions: ActionOption[]
  disabled?: boolean
  dragProvided: DraggableProvided
  dragSnapshot: DraggableStateSnapshot
  errorMessage?: string
  files: FilesType
  index: number
  isLast: boolean
  personalizationList: PersonalizationType
  onAddToLibrary: (action: LocalNonEmptyAction) => Promise<void | Error>
  onChange: (value: LocalActionType, index: number) => void
  onMove: (from: number, to: number) => void
  onRemove: (index: number) => void
}

const ActionListItem: React.FC<Props> = ({
  action,
  actionOptions,
  disabled,
  dragProvided,
  dragSnapshot,
  errorMessage,
  files,
  index,
  isLast,
  personalizationList,
  onAddToLibrary,
  onChange,
  onMove,
  onRemove,
}) => {
  const handleActionChange = React.useCallback(
    ({ value }: { value: LocalActionType }) => {
      onChange(value, index)
    },
    [index, onChange],
  )
  const handleActionMove = React.useCallback(
    (from: number) => {
      onMove(from, index)
    },
    [index, onMove],
  )
  const handleActionRemove = React.useCallback(() => {
    onRemove(index)
  }, [index, onRemove])

  return (
    <Action
      action={action}
      disabled={disabled}
      dragProvided={dragProvided}
      dragSnapshot={dragSnapshot}
      errorMessage={errorMessage}
      files={files}
      index={index}
      isLast={isLast}
      personalizationList={personalizationList}
      values={actionOptions}
      onChange={handleActionChange}
      onCopy={onAddToLibrary}
      onMove={handleActionMove}
      onRemove={handleActionRemove}
    />
  )
}

export default React.memo(ActionListItem)
